import { Link, Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../auth/useAuth.js';
import { Brand } from '../components/Brand.js';
import { ThemeToggle } from '../components/ThemeToggle.js';

export function AppLayout() {
  const { loading, authenticated, username, logout } = useAuth();

  if (loading) {
    return (
      <div className="page">
        <p className="muted">جارٍ التحقق من الجلسة…</p>
      </div>
    );
  }
  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="app-shell">
      <header className="app-navbar">
        <div className="topbar">
          <Brand />
          <div className="nav-actions">
            <span className="user-chip">{username}</span>
            <ThemeToggle />
            <Link className="btn" to="/plans/new">
              خطة جديدة
            </Link>
            <button type="button" className="btn secondary" onClick={() => void logout()}>
              تسجيل الخروج
            </button>
          </div>
        </div>
      </header>
      <main className="page">
        <Outlet />
      </main>
    </div>
  );
}
